import React from "react";
import { useLanguage } from "../context/LanguageContext";

const KEYS_BG =
  "https://static.prod-images.emergentagent.com/jobs/a9198dff-57f1-4437-9e3e-dffc53d8f216/images/d889906c44d98153962e9e3fd4fe85fd7979db2daf6213175398ef37f74fa26d.png";

export const Musicisti = () => {
  const { t } = useLanguage();

  return (
    <section
      id="musicians"
      data-testid="musicians-section"
      className="relative py-28 lg:py-36 bg-[#0A0A0A] overflow-hidden"
    >
      {/* Decorative bg */}
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none">
        <img
          src={KEYS_BG}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl">
          <div className="overline" data-testid="musicians-overline">
            {t.musicians.overline}
          </div>
          <h2
            data-testid="musicians-title"
            className="font-serif-display font-light mt-5 text-4xl md:text-5xl lg:text-6xl text-[#FDFBF7] leading-[1.05]"
          >
            {t.musicians.title}
          </h2>
          <p className="mt-6 text-[#A1A1AA] text-base lg:text-lg leading-relaxed font-light">
            {t.musicians.subtitle}
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {t.musicians.groups.map((group, i) => (
            <div
              key={i}
              data-testid={`musician-group-${i}`}
              className="bg-[#0A0A0A] p-8 lg:p-10 group hover:bg-[#111111] transition-colors duration-500 min-h-[280px]"
            >
              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-serif-bodoni text-[#D4AF37] text-2xl">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-serif-display text-2xl text-[#FDFBF7]">
                  {group.name}
                </h3>
              </div>
              <ul className="space-y-3">
                {group.members.map((m, j) => (
                  <li
                    key={j}
                    data-testid={`musician-${i}-${j}`}
                    className="text-[#A1A1AA] text-sm lg:text-[15px] leading-relaxed font-light pl-4 relative before:content-[''] before:absolute before:left-0 before:top-[0.7em] before:w-2 before:h-px before:bg-[#D4AF37]/50 group-hover:before:bg-[#D4AF37] before:transition-colors"
                  >
                    {m}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Musicisti;
